import { HttpClient } from '@angular/common/http';

import { BehaviorSubject, throwError } from 'rxjs';
import { catchError, take } from 'rxjs/operators';

import { ServiceLocator } from '@core/services';

import { endpoints, settings } from '@environment';

import { AuthService } from '@auth/services';

import { LOGLEVEL } from './constants';
import { LogEntry, LoggerTransport } from './interfaces';

export class HttpTransport implements LoggerTransport {
  logs$: BehaviorSubject<LogEntry[]> = new BehaviorSubject<LogEntry[]>([]);
  interval: NodeJS.Timer;

  constructor() {
    // listen to the logs array. if we get a certain amount or reach a time threshold then
    // send the log entries to the backend to be persisted and clear the local array
    this.logs$.subscribe((logs) => {
      if (logs && logs.length && logs.length === settings.clientLogThreshold) {
        this.flush();
      }
    });

    this.interval = setInterval(() => {
      this.flush();
    }, settings.clientLogTimeout);
  }

  log(logEntry: LogEntry) {
    if (logEntry.level === LOGLEVEL.DISABLE) {
      return;
    }

    this.logs$.next([...this.logs$.value, logEntry]);
  }

  flush() {
    const logs = Array.from(this.logs$.value);

    if (logs.length > 0) {
      const httpService: HttpClient = ServiceLocator.injector.get(HttpClient);
      const authService: AuthService = ServiceLocator.injector.get(AuthService);

      let clientNameId: string;

      try {
        authService.nameid$.pipe(take(1)).subscribe((nameid) => {
          if (nameid) {
            clientNameId = nameid;
          }
        });
      } catch {}

      for (const entry of logs) {
        entry.nameId = clientNameId;
      }

      httpService
        .post(endpoints.log.client, logs)
        .pipe(
          catchError((error) => {
            return throwError(() => error);
          })
        )
        .subscribe((_response) => {
          this.logs$.next([]);
        });
    }
  }
}
